export const ANNEXURES = {
    b: {
        key: "b",
        tab: "Annexure B",
        title: "Annexure B: List of Channel Partners (Franchisee / Distributors / LCO / Last Mile Providers)",
        columns: [
            { key: "partner_name", label: "Name of Channel Partner" },
            { key: "address", label: "Complete Address" },
            { key: "contact_details", label: "Contact Details & Email ID" },
            { key: "activation_date", label: "Date of Activation", type: "date" },
            { key: "cable_operator_license", label: "Authorized Cable Operator (Regn / License No. & Date of Ministry of I&B)" },
            { key: "node_location", label: "Location of ISP Node(s) / POP(s)" },
            { key: "customers_served", label: "No. of Customers Served", type: "number" },
            { key: "locality_served", label: "Locality Served" },
            { key: "agreement_details", label: "Date of Agreement & Agreement Period" }
        ]
    },
    c: {
        key: "c",
        tab: "Annexure C",
        title: "Annexure C: Internet Leased Line (ILL) Customer Details",
        columns: [
            { key: "customer_name", label: "Name of Customer" },
            { key: "ip_address", label: "IP Address Allotted" },
            { key: "bandwidth", label: "Bandwidth Capacity Provided" },
            { key: "installation_address", label: "Address of Installation" },
            { key: "installation_date", label: "Date of Installation / Commissioning", type: "date" },
            { key: "purpose", label: "Purpose of ILL" },
            { key: "contact_name", label: "Contact Name" },
            { key: "contact_phone", label: "Contact Phone" },
            { key: "contact_email", label: "Contact Email" }
        ]
    }
};
